// extracted by mini-css-extract-plugin
export default {"card":"UserCard_card__Ka9iU","user":"UserCard_user__OpI9J","arrow":"UserCard_arrow__SnCWK"};